import React, { useEffect, useState } from "react";
import { Badge, Col, Modal, Row, Table } from "react-bootstrap";
import DateFormat from "components/DateFormat";
import DefaultCurrency from "components/DefaultCurrency";

const PaymentDetails = ({ doc, setDoc }) => {
  // states
  const [show, setShow] = useState(true);

  // effects
  useEffect(() => {
    if (doc) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [doc]);

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
          setDoc(null);
        }}
      >
        <Modal.Header closeButton>{doc.docNumber}</Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={6} sm={3}>
              Doc Type:
            </Col>
            <Col xs={6} sm={3}>
              <Badge bg="primary">{doc.type}</Badge>
            </Col>
            <Col xs={6} sm={3}>
              Status:
            </Col>
            <Col xs={6} sm={3}>
              <b>{doc.status}</b>
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={3}>
              Doc Number:
            </Col>
            <Col xs={6} sm={3}>
              {doc.docNumber}
            </Col>
            <Col xs={6} sm={3}></Col>
            <Col xs={6} sm={3}></Col>
          </Row>
          <Row>
            <Col xs={6} sm={3}>
              Doc Date:
            </Col>
            <Col xs={6} sm={3}>
              <DateFormat value={doc.date} />
            </Col>
            <Col xs={6} sm={3}>
              Due Date:
            </Col>
            <Col xs={6} sm={3}>
              <DateFormat value={doc.dueDate} />
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={3}>
              Amount:
            </Col>
            <Col xs={6} sm={3}>
              <DefaultCurrency value={doc.amount} />
            </Col>
            <Col xs={6} sm={3}>
              Balance:
            </Col>
            <Col xs={6} sm={3}>
              <DefaultCurrency value={doc.balance} />
            </Col>
          </Row>
          <Row className="mt-5">
            <Col xs={12} className="overflow-auto h-50vh">
              <Table responsive striped hover bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {doc.details?.map((detail, index) => (
                    <tr key={detail.id}>
                      <td>{index + 1}</td>
                      <td>{detail.item}</td>
                      <td>{detail.quantity}</td>
                      <td>
                        <DefaultCurrency value={detail.price} />
                      </td>
                      <td>
                        <DefaultCurrency
                          value={detail.quantity * detail.price}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default PaymentDetails;
